import { useLocales } from '@shared/locales'
import { Modal } from 'antd'

import { ActionsType } from './types'

export const PreviewDocument = ({ document, ...props }: ActionsType) => {
  const { t } = useLocales()

  return (
    <Modal
      width={800}
      title={t('generic.preview')}
      cancelButtonProps={{ hidden: true }}
      okText={t('buttons.cancel')}
      onOk={props.onCancel}
      {...props}
    >
      <iframe
        title="document"
        width="100%"
        height="820px"
        loading="lazy"
        src={`${
          document.file_legacy_url || document.attachment?.file
        }#toolbar=0`}
        allowFullScreen
      />
    </Modal>
  )
}
